import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.search.valueChanges
      .pipe(debounceTime(400))
      .subscribe(value => this.searchEmitter.emit(value))
  }

  search = new FormControl('')

  @Output("search") searchEmitter = new EventEmitter<string>()
}
